import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { name, Fetch, Login, Logout, isScreen, PostCaptcha, VerifyCaptcha, } from '@store/session/service';
import { createSlice } from '@reduxjs/toolkit';
var Slice = createSlice({
    name: name,
    initialState: {
        logged: false,
        unauthorized: false,
    },
    reducers: {
        unauthorized: function (state, _action) {
            state.unauthorized = true;
            state.logged = false;
        },
    },
    extraReducers: function (builder) {
        builder
            /** 发起登录请求 */
            .addCase(Login.pending, function (state) {
            state.logining = true;
            delete state.loginingError;
        })
            /** 登录请求成功 */
            .addCase(Login.fulfilled, function (state) {
            state.logining = false;
        })
            /** 登录请求失败 */
            .addCase(Login.rejected, function (state, action) {
            state.logining = false;
            state.loginingError = action.error.message;
        })
            /** 退出登录 */
            .addCase(Logout.pending, function (state) {
            state.logouting = true;
        })
            .addCase(Logout.fulfilled, function (state) {
            state.logouting = true;
            state.unauthorized = true;
            state.logged = false;
        })
            .addCase(Logout.rejected, function (state, action) {
            state.logouting = true;
            state.logoutingError = action.error.message;
        })
            /** 获取 screen 显示数据 */
            .addCase(isScreen.pending, function (state) {
            state.isShowScreen = true;
            delete state.isShowScreenError;
        })
            .addCase(isScreen.fulfilled, function (state) {
            state.isShowScreen = false;
        })
            .addCase(isScreen.rejected, function (state, action) {
            state.isShowScreen = false;
            state.isShowScreenError = action.error.message;
        })
            /** 发起获取当前登录用户信息请求 */
            .addCase(Fetch.pending, function (state) {
            state.fetching = true;
            delete state.fetchingError;
        })
            /** 获取当前登录用户信息成功 */
            .addCase(Fetch.fulfilled, function (state) {
            state.fetching = false;
        })
            /** 获取当前登录用户信息失败 */
            .addCase(Fetch.rejected, function (state, action) {
            state.fetching = false;
            state.fetchingError = action.error.message;
        })
            /** 发起获取找回密码验证码 */
            .addCase(PostCaptcha.pending, function (state) {
            state.posting = true;
            delete state.postingError;
        })
            /** 获取找回密码验证码成功 */
            .addCase(PostCaptcha.fulfilled, function (state) {
            state.posting = false;
        })
            /** 获取找回密码验证码失败 */
            .addCase(PostCaptcha.rejected, function (state, action) {
            state.posting = false;
            state.postingError = action.error.message;
        })
            /** 发起校验验证码请求 */
            .addCase(VerifyCaptcha.pending, function (state) {
            state.verifying = true;
            delete state.verifyingError;
        })
            /** 发起校验验证码请求 */
            .addCase(VerifyCaptcha.fulfilled, function (state, action) {
            state.verifying = false;
            state.uid = action.payload.uid;
            state.xuexinID = action.payload.xuexinID;
        })
            /** 发起校验验证码请求 */
            .addCase(VerifyCaptcha.rejected, function (state, action) {
            state.verifying = false;
            state.verifyingError = action.error.message;
        })
            /** 登录成功或者获取当前登录用户成功时，触发 */
            .addMatcher(function (action) {
            return (action.type === Login.fulfilled.type ||
                action.type === Fetch.fulfilled.type);
        }, function (state, action) {
            state.userId = action.payload.xuexinID;
            state.token = action.payload.token;
            state.logged = true;
            state.unauthorized = false;
            sessionStorage.setItem('token', "" + action.payload.token);
        });
    },
});
var stateSelector = createSelector(function (state) { return state; }, function (state) { return state.session; });
export var useSessionState = function () {
    return useSelector(stateSelector);
};
export var useStatus = function (action) {
    return useSessionState()[action];
};
export var useError = function (action) {
    var state = useSessionState();
    var error = null;
    switch (action) {
        case 'fetching':
            error = state.fetchingError;
            break;
        case 'isShowScreen':
            error = state.isShowScreenError;
            break;
        case 'logining':
            error = state.loginingError;
            break;
        case 'posting':
            error = state.postingError;
            break;
        case 'verifying':
            error = state.verifyingError;
            break;
        case 'resetting':
            error = state.resettingError;
            break;
        case 'updatingPwd':
            error = state.updatingPwdError;
            break;
        default:
            break;
    }
    return error;
};
export var useUserId = function () {
    return useSessionState().userId;
};
export var useAuthorization = function () {
    return useSessionState().token;
};
export var reducer = Slice.reducer, actions = Slice.actions;
